import { Alert, InputAdornment, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
  InputControl,
  ScrollButton,
  SearchChip,
  SelectChip,
} from "../../../shared";
import TemplateCustomTable from "../../Templates/components/TemplateCustomTable";
import CloseIcon from "@mui/icons-material/Close";
import ProductSplitUi from "../../Templates/components/ProductSplitUi";

export const EditProductionChart = ({
  categorylistQuery,
  productionchart,
  onChangeFilter,
  resetRegenerateSearch,
  onSearchChange,
  handleCustomFieldChange,
  recipelistQuery,
  setProductionchart,
  selectedIndex,
  setSelectedIndex,
  handleBatchSplitUpdate,
  editedMap,
  setEditedMap,
  setFocusedField,
  focusedField,
  updateProductionchartBatchSplit,
  handleAddBatch,
  handleDeleteBatch,
  handleDeleteBatchDialog,
  globalData,
}) => {
  const isBowlCapacityExceed = productionchart?.isBowlcapaciytyExceed;

  return (
    <>
      {isBowlCapacityExceed ? (
        <>
          <Alert
            elevation={0}
            severity="warning"
            sx={{
              p: "0px 16px",
              alignItems: "center",
              borderRadius: 0,
              boxShadow: "none",
            }}
          >
            One or more batches have exceeded their bowl capacity. Please adjust
            the product quantities if necessary.
          </Alert>
          <ProductSplitUi
            batchDetails={productionchart?.batchDetails}
            setTemplates={setProductionchart}
            handleBatchSplitUpdate={handleBatchSplitUpdate}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            setEditedMap={setEditedMap}
            setFocusedField={setFocusedField}
            editedMap={editedMap}
            focusedField={focusedField}
            updateBatchSplit={updateProductionchartBatchSplit}
            handleAddBatch={handleAddBatch}
            handleDeleteBatch={handleDeleteBatch}
            handleDeleteBatchDialog={handleDeleteBatchDialog}
            templates={productionchart}
            globalData={globalData}
            middleContentHeight={36}
          />
        </>
      ) : (
        <>
          <CategoryScrollHeader
            {...{
              onSearchChange,
              onCategoryChange: onChangeFilter,
              selectedCategory: productionchart?.filter.category,
              searchValue: productionchart.filter.search,
              groupData: productionchart?.groupedDatas,
              resetRegenerateSearch,
              resultRows: productionchart?.templateResultRows,
              fullList: productionchart?.completeTemplateCategories,
              category: categorylistQuery?.data,
              totalSearchResult: productionchart.totalTemplateSearchResult
            }}
          />
          <TemplateCustomTable
            rows={productionchart?.templateResultRows}
            handleCustomFieldChange={handleCustomFieldChange}
            data={productionchart}
            recipelistQuery={recipelistQuery}
          />
        </>
      )}
    </>
  );
};

const CategoryScrollHeader = ({
  onSearchChange,
  onCategoryChange,
  selectedCategory,
  searchValue,
  groupData,
  resetRegenerateSearch,
  totalSearchResult = 0,
  resultRows = [],
  fullList = [],
  category = [],
}) => {
  const [search, setSearch] = useState("");

  const categoryRef = useRef(null);

  const handleHorizontalScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
    }, speed);
  };

  const onChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    onSearchChange(value, fullList);
  };

  const clearSearch = () => {
    setSearch("");
    resetRegenerateSearch();
  };

  useEffect(() => {
    return () => {
      clearSearch();
    };
  }, []);

  return (
    <Stack
      direction="row"
      gap="8px"
      alignItems="center"
      pl="16px"
      py="8px"
      height="52px"
      position="sticky"
      top={0}
    >
      <InputControl
        sx={{ width: "200px", borderRadius: "10px" }}
        type="table-search"
        placeholder="Search"
        onChange={onChange}
        value={search}
        endAdornment={
          searchValue && (
            <InputAdornment sx={{ cursor: "pointer" }} position="end">
              <CloseIcon size="large" onClick={clearSearch} />
            </InputAdornment>
          )
        }
      />

      <ScrollButton
        categoryRef={categoryRef}
        onClick={handleHorizontalScroll}
        step={-10}
      >
        <img alt="details" src="/icons/Intersect.png" />
      </ScrollButton>

      {search && <SearchChip value={search} count={totalSearchResult} />}

      <Stack
        direction="row"
        overflow="auto"
        gap="8px"
        className="scroll-hide"
        ref={categoryRef}
      >
        {category.map((v, i) => (
          <SelectChip
            key={i}
            value={v}
            isSelected={
              search
                ? false
                : selectedCategory
                  ? selectedCategory === v.id
                  : i === 0
            }
            onClick={() => {
              !search && onCategoryChange(v, groupData, i);
            }}
            sx={search && { cursor: "not-allowed" }}
          />
        ))}
      </Stack>
      <ScrollButton
        categoryRef={categoryRef}
        onClick={handleHorizontalScroll}
        step={10}
      >
        <img alt="details" src="/icons/Intersect1.png" />
      </ScrollButton>
    </Stack>
  );
};
